import { api } from '../../../api';

export interface ApproveTenderRequest {
  comments?: string;
}

export interface RejectTenderRequest {
  comments: string;
}

export interface ApprovalResponse {
  message: string;
}

export interface PendingApproval {
  id: string;
  referenceNo: string;
  description: string;
  category: string;
  publishingDate: string;
  submissionDeadline: string;
  openingDate: string | null;
  stage: string;
  approvalStatus: string;
  approvedById: string | null;
  approvedAt: string | null;
  approvalComments: string | null;
  createdAt: string;
  updatedAt: string;
  savedBy?: {
    id: string;
    fullName: string;
    email: string;
  } | null;
  documents: Array<{
    id: string;
    fileName: string;
    fileSize: number;
    uploadedAt: string;
    type: string;
  }>;
}

// Submit tender for approval
export const submitForApproval = async (tenderId: string): Promise<ApprovalResponse> => {
  const response = await api.post(`/tenders/${tenderId}/submit-approval`);
  return response.data;
};

// Approve tender
export const approveTender = async (tenderId: string, data: ApproveTenderRequest): Promise<ApprovalResponse> => {
  const response = await api.post(`/tenders/${tenderId}/approve`, data);
  return response.data;
};

// Reject tender
export const rejectTender = async (tenderId: string, data: RejectTenderRequest): Promise<ApprovalResponse> => {
  const response = await api.post(`/tenders/${tenderId}/reject`, data);
  return response.data;
};

// Get pending approvals (returns both tenders and evaluation reports)
export const getPendingApprovals = async (): Promise<{
  tenders: PendingApproval[];
  evaluationReports: any[];
}> => {
  const response = await api.get('/tenders/pending-approvals');
  return response.data;
}; 